export default {
  namespaced: true,
  state: {
    obj: {
      modal: false,
      message: '',
      type: 'default',
      time: 5000, 
    },
  },
  getters: {
    obj: state => state.obj,
  },
  mutations: {
    objMutate(state, data) {
      state.obj = data;
    },
  },
  actions: {
    closeSnackbar(context){
      context.commit('objMutate', {
        modal: false,
        message: '',
        type: 'default',
        time: 5000,
      });
    },
    setSnackbar(context, data) {
      context.commit('objMutate', {
        modal: true,
        message: data.message,
        type: data.type ?  data.type : 'default',
        time: data.time ? data.time : 5000,
      });
    },
  },
};
